const downloadFilesType = {
  ORDERED_PARTS: 'mm_ordered_parts',
  MM_WAREHOUSE: 'mm_warehouse',
  MM_ASSEMBLY_ORDER: 'mm_assembly_order',
  VEHICLE_MAP: 'vehicle_map'
};

export default downloadFilesType;
